export const categories = [
  {
    id: 1,
    name: "影视精选",
    slug: "film-tv",
    description: "汇聚国产优秀影视作品深度解读与推荐",
    icon: "ri-movie-2-line",
    articleCount: 128,
    color: "accent",
  },
  {
    id: 2,
    name: "文学创作",
    slug: "literature",
    description: "发现本土原创文学作品与创作分享",
    icon: "ri-book-open-line",
    articleCount: 96,
    color: "secondary",
  },
  {
    id: 3,
    name: "音乐之声",
    slug: "music",
    description: "聆听国产原创音乐人的精彩作品",
    icon: "ri-music-2-line",
    articleCount: 84,
    color: "accent",
  },
  {
    id: 4,
    name: "视觉艺术",
    slug: "visual-art",
    description: "探索本土视觉艺术家的创意世界",
    icon: "ri-palette-line",
    articleCount: 67,
    color: "secondary",
  },
  {
    id: 5,
    name: "科技前沿",
    slug: "tech",
    description: "追踪国产科技创新与数码产品动态",
    icon: "ri-cpu-line",
    articleCount: 112,
    color: "accent",
  },
  {
    id: 6,
    name: "生活方式",
    slug: "lifestyle",
    description: "分享国产生活美学与品质消费指南",
    icon: "ri-heart-line",
    articleCount: 73,
    color: "secondary",
  },
  {
    id: 7,
    name: "历史文化",
    slug: "history-culture",
    description: "传承中华优秀传统文化与历史故事",
    icon: "ri-building-2-line",
    articleCount: 91,
    color: "accent",
  },
  {
    id: 8,
    name: "游戏动漫",
    slug: "game-anime",
    description: "聚焦国产游戏与动漫产业发展动态",
    icon: "ri-gamepad-line",
    articleCount: 105,
    color: "secondary",
  },
];

export const articles = [
  {
    id: 1,
    title: "国产科幻电影的崛起：从《流浪地球》到未来",
    slug: "guochan-kehuan-dianying-jueqi",
    excerpt: "近年来，国产科幻电影迎来了前所未有的发展机遇。从《流浪地球》系列到更多优秀作品的涌现，中国科幻电影正在用独特的东方叙事征服全球观众。",
    content: `<p>近年来，国产科幻电影迎来了前所未有的发展机遇。从《流浪地球》系列在全球范围内取得的巨大成功，到多部制作精良的国产科幻作品陆续问世，中国电影人正在用独特的东方视角和叙事方式重新定义科幻这一类型。</p>

<h2>国产科幻的里程碑</h2>

<p>《流浪地球》无疑是中国科幻电影的一座里程碑。这部改编自刘慈欣同名小说的电影，不仅在国内取得了惊人的票房成绩，更在国际市场上获得了广泛关注。影片中展现的"带着地球去流浪"这一独特概念，深刻体现了中国人对家园的深厚情感，与西方科幻中常见的"逃离地球"形成了鲜明对比。</p>

<p>这一成功并非偶然。它背后是中国电影工业多年来的技术积累和人才储备。从特效制作到场景设计，从科学顾问到道具制作，每一个环节都凝聚着无数电影人的心血。</p>

<h2>东方叙事的独特魅力</h2>

<p>国产科幻电影的独特之处在于其深深植根于中华文化的叙事逻辑。不同于好莱坞科幻片常见的个人英雄主义，国产科幻更倾向于展现集体力量和人定胜天的精神。这种价值观的输出，正在让全球观众看到一种全新的科幻表达方式。</p>

<p>同时，国产科幻也在积极探索多元化的题材方向。从太空探索到人工智能，从时间旅行到平行宇宙，创作者们正在不断拓宽国产科幻的边界。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20cinematic%20scene%20with%20futuristic%20cityscape%20and%20warm%20golden%20lighting%2C%20epic%20scale%2C%20dramatic%20atmosphere%2C%20cinematic%20composition%2C%20clean%20background&width=800&height=450&seq=article-film-01&orientation=landscape",
    category: "影视精选",
    categorySlug: "film-tv",
    author: "影评人老王",
    publishDate: "2026-07-28",
    tags: ["科幻电影", "流浪地球", "国产电影", "影视推荐"],
    viewCount: 15820,
    featured: true,
  },
  {
    id: 2,
    title: "探索国产独立音乐的无限可能",
    slug: "guochan-duli-yinyue-wuxiankeneng",
    excerpt: "国产独立音乐正在经历一场静默的革命。从民谣到电子，从摇滚到实验音乐，越来越多的独立音乐人正在用自己的声音定义这个时代。",
    content: `<p>国产独立音乐正在经历一场静默的革命。从地下酒吧到大型音乐节，从独立厂牌到流媒体平台，越来越多的独立音乐人正在用自己独特的声音定义这个时代的音乐景观。</p>

<h2>独立音乐的新生态</h2>

<p>随着流媒体平台的普及和音乐制作工具的民主化，独立音乐人有了更多展示自己才华的渠道。不再依赖传统唱片公司的资源，许多音乐人选择通过社交媒体和音乐平台直接与乐迷建立联系。</p>

<p>这种去中心化的音乐生态，让更多元的声音得以被听到。从西南地区的民族融合音乐，到东部沿海城市的电子实验，国产独立音乐呈现出前所未有的丰富面貌。</p>

<h2>值得关注的独立音乐人</h2>

<p>近年来，一批优秀的独立音乐人正在崭露头角。他们的作品不仅在音乐性上有着极高的水准，更在歌词中融入了对当下社会生活的深刻思考。这些音乐人正在用自己的方式，书写属于这个时代的声音记忆。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20indie%20music%20live%20performance%20with%20warm%20stage%20lighting%2C%20intimate%20venue%20atmosphere%2C%20acoustic%20instruments%2C%20creative%20composition%2C%20soft%20ambient%20lighting&width=800&height=450&seq=article-music-01&orientation=landscape",
    category: "音乐之声",
    categorySlug: "music",
    author: "音乐编辑小李",
    publishDate: "2026-07-25",
    tags: ["独立音乐", "原创音乐", "音乐推荐", "本土文化"],
    viewCount: 8920,
    featured: true,
  },
  {
    id: 3,
    title: "当代中国文学的新生力量",
    slug: "dangdai-zhongguo-wenxue-xinsheng",
    excerpt: "新一代中国作家正在世界文坛崭露头角。他们的作品既有深厚的文化底蕴，又充满对现代生活的敏锐观察，展现了当代中国文学的多元面貌。",
    content: `<p>新一代中国作家正在世界文坛崭露头角。从获得国际文学大奖的科幻作家，到在社交媒体上引发热议的青年诗人，当代中国文学正在以一种前所未有的活力蓬勃发展。</p>

<h2>多元化的创作方向</h2>

<p>当代青年作家的创作方向呈现出高度的多元化特征。有人深耕现实主义传统，用细腻的笔触描绘普通人的生活百态；有人大胆探索科幻与奇幻的边界，在想象的世界中讨论深刻的哲学命题；还有人将目光投向历史深处，在过往的故事中寻找当下的意义。</p>

<p>这种多元化的创作生态，正是中国文学繁荣发展的生动体现。每一位作家都在用自己的方式，丰富着中国文学的表达空间。</p>

<h2>走向世界的中国故事</h2>

<p>随着中国文学在国际上的影响力不断提升，越来越多的中国作家作品被翻译成多种语言在全球出版。这些作品不仅让世界看到了中国文学的艺术成就，更让全球读者通过文学这一窗口，深入了解了当代中国的社会与文化。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20literature%20books%20on%20wooden%20desk%20with%20warm%20reading%20lamp%2C%20cozy%20library%20atmosphere%2C%20calligraphy%20elements%2C%20soft%20natural%20light%2C%20elegant%20composition&width=800&height=450&seq=article-lit-01&orientation=landscape",
    category: "文学创作",
    categorySlug: "literature",
    author: "文化观察员",
    publishDate: "2026-07-22",
    tags: ["当代文学", "原创文学", "青年作家", "文化观察"],
    viewCount: 12450,
    featured: true,
  },
  {
    id: 4,
    title: "国产手机摄影：记录生活的新方式",
    slug: "guochan-shouji-sheying-jilu",
    excerpt: "随着国产手机影像技术的飞速发展，手机摄影已经成为越来越多人记录生活、表达创意的重要方式。",
    content: `<p>随着国产手机影像技术的飞速发展，手机摄影已经成为越来越多人记录生活、表达创意的重要方式。从旗舰机型的专业级拍摄能力到中端机型的出色性价比，国产手机正在重新定义移动摄影的可能性。</p>

<h2>技术创新的力量</h2>

<p>国产手机厂商在影像技术上的持续投入和创新，让手机摄影的画质和功能不断突破。从大底传感器到计算摄影算法，从光学防抖到AI场景识别，每一项技术的进步都在缩小手机与专业相机之间的差距。</p>

<p>特别值得一提的是，国产手机在人像摄影和夜景拍摄方面的表现尤为出色，这些进步让普通用户也能轻松拍出令人惊艳的照片。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Smartphone%20photography%20with%20Chinese%20cityscape%20at%20sunset%2C%20warm%20golden%20hour%20lighting%2C%20modern%20urban%20scene%2C%20clean%20minimal%20composition%2C%20professional%20product%20photography&width=800&height=450&seq=article-tech-01&orientation=landscape",
    category: "科技前沿",
    categorySlug: "tech",
    author: "科技博主阿明",
    publishDate: "2026-07-20",
    tags: ["手机摄影", "国产手机", "数码科技", "生活方式"],
    viewCount: 21300,
    featured: false,
  },
  {
    id: 5,
    title: "中国传统纹样在现代设计中的新生",
    slug: "zhongguo-chuantong-wenyang-xiandai",
    excerpt: "越来越多的中国设计师正在从传统纹样中汲取灵感，将千年文化元素融入当代设计实践，创造出既有东方韵味又符合现代审美的作品。",
    content: `<p>越来越多的中国设计师正在从传统纹样中汲取灵感，将千年文化元素融入当代设计实践。从青铜器上的兽面纹到宋瓷的冰裂纹，从敦煌壁画的飞天图案到明清家具的雕花纹饰，中国传统纹样正在现代设计中焕发新生。</p>

<h2>传统与现代的对话</h2>

<p>设计师们并非简单地复制传统纹样，而是在深入理解其文化内涵的基础上进行创新性的转化。有的将传统纹样解构重组，创造全新的视觉语言；有的将传统工艺与现代材料结合，探索材质表达的新可能；还有的将传统美学理念融入品牌设计，打造具有东方辨识度的品牌形象。</p>

<p>这种传统与现代的对话，不仅让中国设计在国际舞台上赢得了更多关注，也让传统文化以一种更具活力的方式融入了当代生活。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20traditional%20patterns%20and%20modern%20design%20fusion%2C%20textile%20design%20studio%20with%20warm%20natural%20lighting%2C%20elegant%20composition%2C%20cultural%20elements%2C%20clean%20aesthetic&width=800&height=450&seq=article-art-01&orientation=landscape",
    category: "视觉艺术",
    categorySlug: "visual-art",
    author: "设计观察者",
    publishDate: "2026-07-18",
    tags: ["传统纹样", "现代设计", "文化传承", "视觉艺术"],
    viewCount: 7650,
    featured: false,
  },
  {
    id: 6,
    title: "国产精品咖啡文化的悄然兴起",
    slug: "guochan-jingpin-kafei-wenhua",
    excerpt: "在咖啡文化席卷全球的背景下，国产精品咖啡正在走出自己的特色之路，从云南咖啡庄园到城市精品咖啡馆，一条完整的产业链正在形成。",
    content: `<p>在咖啡文化席卷全球的背景下，国产精品咖啡正在走出自己的特色之路。从云南高山上的咖啡庄园到城市角落里的精品咖啡馆，从咖啡豆的精品种植到匠心独具的冲泡技艺，一条完整的国产精品咖啡产业链正在形成。</p>

<h2>云南咖啡的崛起</h2>

<p>云南，这片拥有得天独厚气候条件的土地，正在成为中国精品咖啡的核心产区。这里的咖啡豆以其独特的风味特征——明亮的果酸、浓郁的花香和丝滑的口感——正在国际咖啡评分中获得越来越高的评价。</p>

<p>越来越多的咖啡农开始转向精品化种植，通过改良品种、优化加工工艺，不断提升国产咖啡豆的品质。这不仅提高了农民的收入，也让中国咖啡在世界咖啡版图上占据了越来越重要的位置。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20specialty%20coffee%20shop%20interior%20with%20warm%20wooden%20furniture%2C%20barista%20pouring%20coffee%2C%20cozy%20atmosphere%2C%20natural%20light%20from%20large%20windows%2C%20minimal%20aesthetic&width=800&height=450&seq=article-life-01&orientation=landscape",
    category: "生活方式",
    categorySlug: "lifestyle",
    author: "生活编辑小美",
    publishDate: "2026-07-15",
    tags: ["精品咖啡", "云南咖啡", "生活方式", "品质生活"],
    viewCount: 11340,
    featured: false,
  },
  {
    id: 7,
    title: "丝绸之路上的文化瑰宝：敦煌艺术再发现",
    slug: "sichouzhilu-dunhuang-yishu",
    excerpt: "敦煌作为丝绸之路上的文化明珠，其壁画艺术和文献典籍一直是学术研究的重要对象。近年来，数字技术为敦煌艺术的保护与传播带来了全新可能。",
    content: `<p>敦煌，这座位于丝绸之路上的文化明珠，以其举世闻名的莫高窟壁画和藏经洞文献吸引了全世界的目光。作为人类文明的杰出代表，敦煌艺术承载着千年的历史记忆和文化交融的智慧。</p>

<h2>数字敦煌的新篇章</h2>

<p>近年来，数字技术的飞速发展为敦煌艺术的保护、研究和传播带来了革命性的变化。通过高精度三维扫描和数字化复原技术，研究人员能够在不接触原壁画的条件下进行深入研究。而虚拟现实和增强现实技术的应用，则让普通观众也能身临其境地感受敦煌艺术的震撼魅力。</p>

<p>数字敦煌项目不仅让这些珍贵的文化遗产得到了更好的保护，更让它们以前所未有的方式走向了世界，让更多人了解并热爱这份属于全人类的文化瑰宝。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Dunhuang%20Mogao%20Caves%20ancient%20Buddhist%20murals%20with%20warm%20desert%20golden%20lighting%2C%20cultural%20heritage%20atmosphere%2C%20artistic%20photography%2C%20rich%20colors%2C%20historical%20composition&width=800&height=450&seq=article-history-01&orientation=landscape",
    category: "历史文化",
    categorySlug: "history-culture",
    author: "文史研究员",
    publishDate: "2026-07-12",
    tags: ["敦煌", "丝绸之路", "文化遗产", "数字技术"],
    viewCount: 9870,
    featured: false,
  },
  {
    id: 8,
    title: "国产独立游戏的黄金时代",
    slug: "guochan-duli-youxi-huangjin",
    excerpt: "国产独立游戏正迎来前所未有的发展机遇。越来越多富有创意和人文关怀的国产独立游戏作品涌现，在全球游戏市场中占据了一席之地。",
    content: `<p>国产独立游戏正迎来前所未有的发展机遇。从Steam平台上的爆款作品到各大游戏展会的获奖常客，国产独立游戏开发者正在用他们的创意和热情，书写着中国游戏产业的新篇章。</p>

<h2>创意驱动的力量</h2>

<p>与大厂制作的商业大作不同，独立游戏的优势在于其独特的创意和强烈的人文表达。国产独立游戏开发者将中国传统文化的元素与现代游戏设计理念相结合，创造出了许多令人耳目一新的作品。</p>

<p>从以中国神话为背景的动作游戏，到探讨当代社会议题的叙事游戏，再到融合水墨画风格的解谜游戏，国产独立游戏正在以多元化的面貌，向世界展示中国游戏开发者的创意实力。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20indie%20game%20development%20studio%20with%20creative%20workspace%2C%20warm%20ambient%20lighting%2C%20digital%20art%20on%20screens%2C%20modern%20minimal%20setup%2C%20artistic%20atmosphere&width=800&height=450&seq=article-game-01&orientation=landscape",
    category: "游戏动漫",
    categorySlug: "game-anime",
    author: "游戏编辑阿杰",
    publishDate: "2026-07-10",
    tags: ["独立游戏", "国产游戏", "游戏产业", "创意设计"],
    viewCount: 16890,
    featured: false,
  },
  {
    id: 9,
    title: "中国动画电影的东方美学复兴",
    slug: "zhongguo-donghua-dianying-dongfang",
    excerpt: "从《大圣归来》到《哪吒之魔童降世》，中国动画电影正在经历一场深刻的东方美学复兴，用独特的视觉语言讲述中国故事。",
    content: `<p>从《大圣归来》到《哪吒之魔童降世》，中国动画电影正在经历一场深刻的东方美学复兴。这些作品不仅在票房上取得了令人瞩目的成绩，更重要的是，它们正在用独特的东方视觉语言，重新定义中国动画电影的艺术高度。</p>

<h2>技术为艺术服务</h2>

<p>国产动画电影的技术进步有目共睹。从角色建模到场景渲染，从动作捕捉到特效合成，中国动画制作的技术水平已经达到了国际一流水准。但更令人欣喜的是，这些技术被恰如其分地运用于艺术表达之中，而非单纯的技术炫技。</p>

<p>例如，《深海》中独具匠心的"粒子水墨"技术，将中国传统水墨画的意境与现代三维动画技术完美融合，创造出了一种前所未有的视觉体验。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20artistic%20scene%20with%20ink%20wash%20painting%20style%2C%20ethereal%20atmosphere%2C%20mythological%20elements%2C%20warm%20golden%20and%20red%20tones%2C%20cinematic%20composition&width=800&height=450&seq=article-anime-01&orientation=landscape",
    category: "影视精选",
    categorySlug: "film-tv",
    author: "影评人老王",
    publishDate: "2026-07-08",
    tags: ["动画电影", "东方美学", "国漫", "影视推荐"],
    viewCount: 23450,
    featured: false,
  },
  {
    id: 10,
    title: "当AI遇见中国书法：科技与传统的碰撞",
    slug: "AI-zhongguo-shufa-keji-chuantong",
    excerpt: "人工智能技术的快速发展正在与传统书法艺术产生有趣的碰撞。AI能否真正理解中国书法的精神内核？这成为一个值得深思的话题。",
    content: `<p>人工智能技术的快速发展正在与传统书法艺术产生有趣的碰撞。当AI能够模仿王羲之的《兰亭序》或颜真卿的《祭侄文稿》时，一个深刻的问题浮出水面：AI能否真正理解中国书法的精神内核？</p>

<h2>技术的边界</h2>

<p>目前，AI在模仿书法风格方面已经取得了令人瞩目的进展。通过深度学习大量书法作品，AI能够生成风格酷似某位书法家的"新作"。然而，书法艺术的精髓不仅仅在于视觉形式，更在于书写者在笔墨之间倾注的情感和精神。</p>

<p>正如古人所说"字如其人"，书法作品是书写者人格、修养和当下心境的综合体现。这种深层次的人文内涵，或许是AI永远无法真正理解和复制的。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20calligraphy%20brush%20and%20digital%20tablet%20side%20by%20side%2C%20warm%20studio%20lighting%2C%20traditional%20meets%20modern%20aesthetic%2C%20clean%20composition%2C%20cultural%20fusion&width=800&height=450&seq=article-tech-02&orientation=landscape",
    category: "科技前沿",
    categorySlug: "tech",
    author: "科技博主阿明",
    publishDate: "2026-07-05",
    tags: ["人工智能", "中国书法", "传统文化", "科技人文"],
    viewCount: 18320,
    featured: false,
  },
  {
    id: 11,
    title: "都市里的诗意栖居：新中式家居美学",
    slug: "dushi-shili-qiju-xinzhongshi",
    excerpt: "新中式家居正在成为当代都市人的理想生活选择。它既保留了中国传统居住文化的精髓，又融入了现代设计的简洁与实用。",
    content: `<p>新中式家居正在成为当代都市人追求的理想生活方式。它既保留了中国传统居住文化的精髓——对自然、空间和意境的追求，又融入了现代设计的简洁线条与实用功能。</p>

<h2>留白的智慧</h2>

<p>新中式家居设计的核心之一是"留白"。不同于西方设计中对空间的填充，新中式设计注重空间的呼吸感，通过恰当的留白营造宁静、从容的居住氛围。这种设计理念源于中国传统绘画和园林艺术，体现了东方哲学中对"空"的深刻理解。</p>

<p>在实际操作中，设计师通过精心选择的家具、恰当的色彩搭配以及自然材质的运用，在有限的空间中创造无限的可能。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20Chinese%20style%20living%20room%20interior%20with%20wooden%20furniture%2C%20warm%20natural%20lighting%2C%20minimal%20design%2C%20elegant%20tea%20set%2C%20serene%20atmosphere%2C%20clean%20composition&width=800&height=450&seq=article-life-02&orientation=landscape",
    category: "生活方式",
    categorySlug: "lifestyle",
    author: "生活编辑小美",
    publishDate: "2026-07-02",
    tags: ["新中式", "家居设计", "生活美学", "品质生活"],
    viewCount: 14560,
    featured: false,
  },
  {
    id: 12,
    title: "非遗传承人的坚守与创新",
    slug: "feiyi-chuancheng-ren-jianshou",
    excerpt: "在快速变迁的时代中，一批非遗传承人正在用自己的坚守和创新，让古老的技艺在现代社会中找到新的生存空间。",
    content: `<p>在快速变迁的时代中，一批非物质文化遗产的传承人正在用自己的坚守和创新，让那些承载着民族记忆的古老技艺在现代社会中找到新的生存空间和发展可能。</p>

<h2>传承的困境与突破</h2>

<p>非遗传承面临的最大挑战之一，是如何让古老的技艺与当代生活产生关联。许多传承人正在积极探索传统技艺的现代表达方式：有的将传统刺绣图案应用于现代服装设计，有的将传统制陶工艺与当代家居产品结合，还有的通过短视频平台让更多人了解和学习传统技艺。</p>

<p>这些创新尝试不仅让非遗项目获得了新的生命力，也让更多年轻人开始关注并参与到传统文化的保护和传承中来。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20intangible%20cultural%20heritage%20craftsman%20working%20in%20traditional%20workshop%2C%20warm%20natural%20lighting%2C%20handmade%20ceramics%2C%20cultural%20preservation%2C%20artistic%20documentary%20style&width=800&height=450&seq=article-history-02&orientation=landscape",
    category: "历史文化",
    categorySlug: "history-culture",
    author: "文史研究员",
    publishDate: "2026-06-28",
    tags: ["非遗", "文化传承", "传统工艺", "创新发展"],
    viewCount: 6710,
    featured: false,
  },
];

export const featuredArticles = articles.filter((a) => a.featured);

export const hotArticles = [...articles].sort((a, b) => b.viewCount - a.viewCount).slice(0, 6);

export const getArticlesByCategory = (slug: string) =>
  articles.filter((a) => a.categorySlug === slug);

export const getArticleById = (id: number) => articles.find((a) => a.id === id);

export const getArticleBySlug = (slug: string) => articles.find((a) => a.slug === slug);

export const getCategoryBySlug = (slug: string) => categories.find((c) => c.slug === slug);